import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"

interface SkeletonProps {
  class?: HTMLAttributes["class"]
}


const __default__ = {
  name: "UiSkeleton",
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(cn)('animate-pulse rounded-md bg-muted', props.class))
  }, null, 2))
}
}

})